import script from "./sw-item-editor-short-text.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-editor-short-text.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-editor-short-text.vue?vue&type=style&index=0&id=f0dab06e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0dab06e"]])

export default __exports__